import { render, staticRenderFns } from "./errorState.vue?vue&type=template&id=2b4b7c38&lang=pug"
import script from "./errorState.vue?vue&type=script&lang=js"
export * from "./errorState.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports